(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zefra-announcement-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zefra-announcement')) {
    customElements.define('zefra-announcement', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.zefra-announcement__toggle');
        if (!button || this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zefra-prototype-timeline"] && !Shopify.designMode) return;
  try {
    function zftInit(scope) {
  scope.querySelectorAll('[data-zft]').forEach(root => {
    if (root.dataset.zftReady) return;
    const cards = Array.from(root.querySelectorAll('[data-zft-card]'));
    const art = root.querySelector('[data-zft-art]');
    const image = root.querySelector('[data-zft-image]');
    const title = root.querySelector('[data-zft-title]:not([data-zft-card])');
    const caption = root.querySelector('[data-zft-caption]:not([data-zft-card])');
    const count = root.querySelector('[data-zft-count]:not([data-zft-card])');
    const number = root.querySelector('[data-zft-paper-number]');
    const progress = root.querySelector('[data-zft-progress]');
    const status = root.querySelector('[data-zft-status]');
    const previous = root.querySelector('[data-zft-previous]');
    const next = root.querySelector('[data-zft-next]');
    const enlarge = root.querySelector('[data-zft-enlarge]');
    const dialog = root.querySelector('[data-zft-dialog]');
    const dialogImage = root.querySelector('[data-zft-dialog-image]');
    const dialogCaption = root.querySelector('[data-zft-dialog-caption]');
    if (!cards.length || !image || !title || !caption || !count || !previous || !next) return;
    let selected = 0;
    const select = (index, announce = true) => {
      selected = Math.max(0, Math.min(index, cards.length - 1));
      const card = cards[selected];
      cards.forEach((item, i) => {
        if (i === selected) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      image.src = card.dataset.zftSrc;
      image.alt = card.dataset.zftAlt;
      image.width = Number(card.dataset.zftWidth);
      image.height = Number(card.dataset.zftHeight);
      art.href = card.href;
      title.textContent = card.dataset.zftTitle;
      caption.textContent = card.dataset.zftCaption;
      count.textContent = card.dataset.zftCount;
      number.textContent = String(selected + 1).padStart(2, '0');
      progress.style.width = `${((selected + 1) / cards.length) * 100}%`;
      previous.disabled = selected === 0;
      next.disabled = selected === cards.length - 1;
      if (announce) status.textContent = `${card.dataset.zftCount}. ${card.dataset.zftTitle}`;
    };
    cards.forEach((card, index) => {
      card.setAttribute('role', 'button');
      card.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(index);
      });
      card.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); select(index); return; }
        let target;
        if (event.key === 'ArrowRight') target = Math.min(index + 1, cards.length - 1);
        if (event.key === 'ArrowLeft') target = Math.max(index - 1, 0);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = cards.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        select(target);
        cards[target].focus();
      });
    });
    previous.addEventListener('click', () => select(selected - 1));
    next.addEventListener('click', () => select(selected + 1));
    if (dialog && typeof dialog.showModal === 'function') {
      const open = () => {
        const card = cards[selected];
        dialogImage.src = card.dataset.zftSrc;
        dialogImage.alt = card.dataset.zftAlt;
        dialogImage.width = Number(card.dataset.zftWidth);
        dialogImage.height = Number(card.dataset.zftHeight);
        dialogCaption.textContent = `${card.dataset.zftTitle} — ${card.dataset.zftCaption}`;
        if (!dialog.open) dialog.showModal();
      };
      art.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open();
      });
      enlarge.hidden = false;
      enlarge.addEventListener('click', open);
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
    root.querySelector('[data-zft-controls]').hidden = false;
    root.dataset.zftReady = 'true';
    select(0, false);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => zftInit(document), { once: true });
else zftInit(document);
document.addEventListener('shopify:section:load', event => zftInit(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zefra-service-photos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('zefra-service-photos'))customElements.define('zefra-service-photos',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('dialog');if(!dialog||typeof dialog.showModal!=='function')return;this.addEventListener('click',event=>{const link=event.target.closest('[data-service-photo]');if(!link)return;event.preventDefault();const source=link.querySelector('img');const image=dialog.querySelector('img');image.src=link.href;image.alt=source.alt;image.width=source.width;image.height=source.height;dialog.querySelector('figcaption').textContent=link.dataset.caption;dialog.showModal();});this.querySelector('[data-service-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});}});
  } catch(e) { console.error(e); }
})();

})();
